"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Still = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var Composition_1 = require("./Composition");

var Still = function Still(props) {
  return (0, jsx_runtime_1.jsx)(Composition_1.Composition, _objectSpread({
    fps: 1,
    durationInFrames: 1
  }, props));
};

exports.Still = Still;